"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
const Badge = props => {
  const theme = (0, _material.useTheme)();
  const backgroundColor = props.backgroundColor || theme.palette.TwClrBgSecondary;
  const borderColor = props.borderColor || theme.palette.TwClrBrdrSecondary;
  const labelColor = props.labelColor || borderColor;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "span",
    sx: {
      backgroundColor,
      border: "1px solid ".concat(borderColor),
      borderRadius: theme.spacing(1),
      display: 'inline-block',
      padding: theme.spacing(0.5, 1),
      width: 'fit-content'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: labelColor,
    component: "span",
    fontSize: "14px",
    fontWeight: 500
  }, props.label));
};
var _default = exports.default = Badge;